import {ComboBoxControl, FormWrapperLabel} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {memo, useEffect} from "react";
import {useSendMail} from "../../../Providers/SendMailProvider";

const RestrictedPostageControl = () => {
    const { control, setValue } = useFormContext();

    const { postageOptions, reset, address, addressOptions, UpdatePostage, sendPageID } = useSendMail();

    const UpdateSelectedPostage = () => {
        if(postageOptions && postageOptions.length === 1) {
            setValue('postage', postageOptions[0].value);
        } else {
            setValue('postage', -1);
        }
    };

    useEffect(() => {
        UpdateSelectedPostage();
    }, [reset, address, sendPageID, addressOptions, postageOptions]);

    return (
        <Controller
            control={control}
            name="postage"
            rules={{ required: 'Postage Option is required', validate: (value) => value === -1 ? 'Postage Option is required' : true }}
            render={({field, fieldState}) =>
                <FormWrapperLabel label={'Postage'} validationMessage={fieldState.error?.message}>
                    {postageOptions.length > 1 ? (
                        <ComboBoxControl
                            name={'postage'}
                            placeholder={'Select Postage...'}
                            forwardValueCallback={(e) => {
                                field.onChange(e);
                                UpdatePostage(e);
                            }}
                            defaultValues={[field.value]}
                            data={postageOptions}
                            singleSelection={true}
                            valueType={'number'}
                        />
                    ) : (
                        <input readOnly={true} value={postageOptions.length === 0 ? '' : postageOptions[0].label} disabled={postageOptions.length === 0} />
                    )}
                </FormWrapperLabel>
            } />
    )
}

export { RestrictedPostageControl }
